<template>
  <div
    class="product"
    :class="{'empty': !product}"
  >
    <div
      v-if="product"
      v-ripple
      class="product-content"
      :style="'background-color:'+product.backcolor+';color:'+product.color"
      @click="$emit('add', product)"
      @touchend="$blurRipple($el)"
    >
      <!-- TITRE PRODUIT -->
      <div class="product-label ellipsis">
        {{ product.label }}
      </div>
      <div>
        <img
          v-show="product.img"
          :src="product.img"
          alt="product"
          class="f-left"
          height="46"
          width="46"
        >
        <!-- QUANTITE -->
        <div
          v-show="product.quantity > 0"
          class="product-quantity"
        >
          <span class="green darken-1 white--text">
            x{{ product.quantity }}
          </span>
          <span class="caption">
            {{ $amount(product.total ? product.total : (product.quantity * product.price)) }}
          </span>
        </div>
        <!-- PRIX -->
        <div
          v-show="product.price"
          class="product-price headline right"
          :style="product.quantity > 0 ? '' : 'padding-top: 24px'"
        >
          {{ $amount(product.price) }}
        </div>
      </div>
    </div>
    <div
      v-else
      class="product-content"
    />
  </div>
</template>

<script>
import { $amount, $blurRipple } from '@/modules/Utils'

export default {
  name: 'ProductKey',

  props: {
    product: { type: Object, default: null }
  },

  methods: {
    $amount,
    $blurRipple
  }
}
</script>

<style scoped>
/* Touche produit */
.product {
  display: inline-flex;
  width: 48%;
  margin: 1%;
  cursor: pointer;
  background-color: #727272;
  vertical-align: top;
}
.product.empty {
  background-color: transparent;
}
.product-content {
  width: 100%;
  height: 76px;
  text-align: right;
  padding: 0 4px;
}
.product-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.product-quantity > .green {
  padding: 2px 2px 2px 0;
  margin-right: 6px;
}
.product-price {
  line-height: 1;
}
</style>
